export const MAXIMUM_PAGINATION = 1000;

export const DEFAULT_PAGE_SIZE = 10;

export const DEFAULT_STALE_TIME = 10 * 1000;

export const DEFAULT_PAGE = 1;

export const CACHE_TIME = 2 * 1000;

export const EMPTY_FILTER_VALUE = 'EMPTY_FILTER_VALUE';

export const NULL_FILTER_VALUE = 'null';

export const PROBE_FETCH_TIMEOUT_MS = 15_000;
